type Props = {
  statusGeral: string;
  statusClass: "success" | "warning" | "danger" | "secondary";

  vacinas: {
    atrasadas: number;
    proximas: number;
    emDia: number;
  };

  parasitas: {
    atrasados: number;
    proximos: number;
    emDia: number;
  };

  proximo?: {
    nome: string;
    data: string;
  } | null;

  apto: boolean;
};

export default function ResumoSaude({
  statusGeral,
  statusClass,
  vacinas,
  parasitas,
  proximo,
  apto,
}: Props) {
  const borda =
    statusClass === "danger"
      ? "border-red-500"
      : statusClass === "warning"
      ? "border-yellow-500"
      : statusClass === "success"
      ? "border-green-500"
      : "border-gray-300";

  const badgeStatus =
    statusClass === "danger"
      ? "bg-red-500 text-white"
      : statusClass === "warning"
      ? "bg-yellow-500 text-black"
      : statusClass === "success"
      ? "bg-green-600 text-white"
      : "bg-gray-400 text-white";

  return (
    <div className={`bg-white rounded-xl border p-4 ${borda}`}>
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex-1 min-w-[260px]">
          <div className="text-sm text-gray-600 mb-2">
            Status de saúde (para hospedagem)
          </div>

          <div className="flex items-center gap-2 flex-wrap mb-2">
            <span className={`text-xs font-semibold px-3 py-1 rounded ${badgeStatus}`}>
              {statusGeral}
            </span>

            <span
              className={`text-xs font-semibold px-3 py-1 rounded ${
                apto ? "bg-green-600 text-white" : "bg-gray-500 text-white"
              }`}
            >
              {apto ? "Apto para hospedagem" : "Não apto para hospedagem"}
            </span>
          </div>

          <div className="text-sm text-gray-700">
            Vacinas — Atrasadas: <b>{vacinas.atrasadas}</b> • Próximas (30 dias):{" "}
            <b>{vacinas.proximas}</b> • Em dia: <b>{vacinas.emDia}</b>
          </div>

          <div className="text-sm text-gray-700 mt-1">
            Parasitários — Atrasados: <b>{parasitas.atrasados}</b> • Próximos (30 dias):{" "}
            <b>{parasitas.proximos}</b> • Em dia: <b>{parasitas.emDia}</b>
          </div>
        </div>

        <div className="text-right min-w-[180px]">
          <div className="text-sm text-gray-600">Próximo vencimento</div>

          {proximo ? (
            <>
              <div className="font-bold text-gray-900">{proximo.nome}</div>
              <div className="text-sm text-gray-800">{proximo.data}</div>
            </>
          ) : (
            <div className="text-sm text-gray-400">—</div>
          )}
        </div>
      </div>
    </div>
  );
}